import React, { FC } from 'react';

import GeneralLayout from 'core/react/layout/GeneralLayout';
import { TepManagement } from 'components/organisms/tep/tep-management';

export const TepManagementPage: FC = () => (
  <GeneralLayout>
    <TepManagement />
  </GeneralLayout>
);
